module.exports = __webpack_public_path__ + "static/media/event-banner.ff24bc62.png";